import { IMaterialExposure } from '../../../sp-types/netExposureType';
import { FormatToShortPriceTemplate } from '../../../utils/FormatValue';
import React from 'react';
interface ExposureCalculationProps {
  totalAmounts: IMaterialExposure;
  netExposure: number;
  exposureColor?: string;
}

export const getExposureCalculation: React.FC<ExposureCalculationProps> = ({
  netExposure,
  totalAmounts: { financialPositions, inventorySum, futureOrder },
  exposureColor,
}) => (
  <div className="p-2 bg-white text-sm text-gray-500 font-normal border-2 border-gray-450 shadow-custom rounded flex flex-col gap-1">
    <div className="flex justify-between">
      <p className="w-28">Future orders</p>
      <p>{FormatToShortPriceTemplate(futureOrder)}</p>
    </div>
    <div className="flex justify-between">
      <p className="w-28">Inventory</p>
      <p>- {FormatToShortPriceTemplate(inventorySum)}</p>
    </div>
    <div className="flex justify-between">
      <p className="w-28">Financial Pos</p>
      <p>- {FormatToShortPriceTemplate(financialPositions)}</p>
    </div>
    <div style={{ color: exposureColor }} className="flex justify-end">
      <p className="border-t border-gray-500 pt-1">&nbsp;&nbsp; {FormatToShortPriceTemplate(netExposure)}</p>
    </div>
  </div>
);
